import React from "react";
import { useSelector } from "react-redux";
import { FaWhatsapp, FaExclamationTriangle } from "react-icons/fa";

const SubscriptionExpired = () => {
  const { subscriptionExpired } = useSelector((state) => state.category);
  const { profile } = useSelector((state) => state.profile);

  if (!subscriptionExpired) return null;

  const handleWhatsappChat = () => {
    const whatsappNumber = profile?.whatsapp || "971500000000"; // Fallback number or logic
    const message = `Hi, I'm trying to access the digital menu but it says 'Service temporarily unavailable'. Please check the subscription status.`;
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 backdrop-blur-md transition-all duration-500 animate-in fade-in">
      <div 
        className="bg-white rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.3)] p-10 max-w-md w-full mx-6 text-center transform transition-all animate-in zoom-in slide-in-from-bottom-10 duration-500 ease-out border border-white/20"
        style={{
          background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative mb-8">
          <div className="w-24 h-24 bg-red-50 rounded-full flex items-center justify-center mx-auto animate-pulse">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
              <FaExclamationTriangle className="text-red-500 text-4xl" />
            </div>
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center">
            <div className="w-3 h-3 bg-red-500 rounded-full animate-ping"></div>
          </div>
        </div>

        <h2 className="text-3xl font-extrabold text-gray-900 mb-4 poppins tracking-tight">
          Service temporarily unavailable
        </h2>

        <p className="text-gray-600 mb-10 leading-relaxed text-lg">
          We apologize for the inconvenience. Our services for this restaurant are temporarily paused. Please reach out to the restaurant team via WhatsApp for any assistance or orders.
        </p>

        <div className="space-y-4">
          <button
            onClick={handleWhatsappChat}
            className="w-full flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20ba5a] text-white font-bold py-4 px-8 rounded-2xl transition-all duration-300 shadow-[0_10px_20px_rgba(37,211,102,0.3)] hover:shadow-[0_15px_30px_rgba(37,211,102,0.4)] hover:-translate-y-1 active:translate-y-0 group"
          >
            <FaWhatsapp className="text-2xl group-hover:scale-110 transition-transform" />
            <span className="text-lg">Chat with us on WhatsApp</span>
          </button>
          
          <p className="text-gray-400 text-sm font-medium pt-4">
            Thank you for your patience
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpired;
